<ng-container *ngIf="shouldRender">
  <div *ngIf="isTableLocked" class="lock-message">
    Please submit the workflow or cancel them to delete the records.
  </div>

 
  <ng-container *ngIf="!loading; else loader">
    <div *ngFor="let table of multipleTables; let i = index" class="table-wrapper" [class.locked]="isTableLocked">
       <div class="file-name-display">
        <h3>{{ table.fileName }}</h3>
        <button *ngIf="!isEditable" mat-icon-button (click)="refreshTable()" matTooltip="Refresh Table">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
      <div class="table-container">
        <div class="table-horizontal-wrapper">
          <table class="custom-table" [class.has-collapsed-cols]="collapsedColumns.size > 0">
            <thead class="table-header">
              <tr>
                <th *ngFor="let col of table.columns; let colIdx = index"
                    [class.frozen-col]="isFrozenColumnIndex(colIdx)"
                    [class.frozen-col-last]="isLastFrozenColumnIndex(colIdx)"
                    [class.no-freeze-row]="data?.freezeRow === false"
                    [class.collapsed-col-header]="isColumnCollapsed(col)"
                    [class.column-divider]="showDivider(col)"
                    [style.left.px]="getFrozenColumnLeftByIndex(colIdx)"
                    (click)="isColumnCollapsed(col) ? toggleColumnCollapse(col, $event) : null">
                  <div class="header-content" *ngIf="!isColumnCollapsed(col)">
                    <span class="header-label">{{ formatHeaderLabel(col) }}</span>
                    <span class="collapse-col-toggle"
                      (click)="toggleColumnCollapse(col, $event)"
                      title="Collapse column">&#9664;</span>
                  </div>
                  <span class="collapsed-col-label" *ngIf="isColumnCollapsed(col)"
                    [title]="'Expand ' + formatHeaderLabel(col)">{{ formatHeaderLabel(col) }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of table.tableData; let rowIdx = index" [class.frozen-body-row]="isFrozenBodyRow(rowIdx, table.tableData.length)">
                <td *ngFor="let col of table.columns; let colIdx = index"
                    [class.frozen-col]="isFrozenColumnIndex(colIdx)"
                    [class.frozen-col-last]="isLastFrozenColumnIndex(colIdx)"
                    [class.frozen-body-row-cell]="isFrozenBodyRow(rowIdx, table.tableData.length)"
                    [class.collapsed-col-cell]="isColumnCollapsed(col)"
                    [class.column-divider]="showDivider(col)"
                    [style.left.px]="getFrozenColumnLeftByIndex(colIdx)"
                    [style.top.px]="getFrozenBodyRowTop(rowIdx, table.tableData.length)"
                    [style.bottom.px]="getFrozenBodyRowBottom(rowIdx, table.tableData.length)">
                  <ng-container *ngIf="!isColumnCollapsed(col)">
                    <ng-container *ngIf="isEditable && !table.isError; else viewMode">
                      <input
                        type="text"
                        class="table-input"
                        [value]="row[col]"
                        (input)="onCellEdit(row, col, $event)"
                      />
                    </ng-container>
                    <ng-template #viewMode>
                      <a *ngIf="col === 'error_stack' && row[col] && row[col] !== 'No Error'" (click)="showError(row[col])" class="error-link">Error</a>
                      <div *ngIf="col !== 'error_stack' || !row[col] || row[col] === 'No Error'" class="view-mode-cell" [class.error-message]="table.isError">
                        {{ row[col] }}
                      </div>
                    </ng-template>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="table-actions" *ngIf="showAddButton">
        <button mat-icon-button class="add-row-btn" (click)="addRow(i)" matTooltip="Add a new row to this table">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  </ng-container>

  <div class="component-actions" *ngIf="data?.actions?.length > 0">
    <ng-container *ngFor="let action of data.actions">
      <button
        *ngIf="isActionVisible(action)"
        mat-raised-button
        class="action-button"
        [ngClass]="{
          'btn-cancel': action.label === 'Cancel',
          'btn-grey': action.label === 'Upload' || action.label === 'Add Record',
          'btn-submit': action.label === 'Submit',
          'action-button-black': !['Cancel', 'Upload', 'Add Record', 'Submit'].includes(action.label)
        }"
        (click)="handleAction(action)"
        [disabled]="(action.label === 'Submit' && isSubmitDisabled) || (action.label === 'Add Record' && isAddRecordDisabled)">
        {{ action.label }}
      </button>
    </ng-container>
  </div>

  <ng-template #loader>
    <p class="loading-text">Loading table...</p>
  </ng-template>
</ng-container>
